/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Template_Field_Regex_PatternsInputs */



/**
* | output |
* | --- |
* | "Regex Patterns" |
*
* @param {Compliance_Template_Field_Regex_PatternsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_template_field_regex_patterns = /** @type {((inputs?: Compliance_Template_Field_Regex_PatternsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Template_Field_Regex_PatternsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Regex-Muster")
	return /** @type {LocalizedString} */ ("Regex Patterns")
});